import React from "react";

const Header = ({ handleLogout }) => {
  return (
    <header className="flex flex-row justify-between items-center px-5 bg-white py-2 shadow-lg">
      <h1 className="text-xl lg:text-2xl text-blue-600 font-bold">Infinity</h1>
      <div>
        <button
          onClick={handleLogout}
          type="button"
          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
        >
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
